import { WrapperMedium } from "../layout/website";
import PageComponent from "../pages/website/Page";
import PageContentSeparator from "../pages/website/PageContentSeparator";
import { EditableResourceFields, Page, Photo } from "../resources/modelTypes";
import { getPhotoByPk, RootState } from "../resources/reduxTypes";
import Content from "./Content";
import { hideLast, hideMd } from "./styles";
import React, { Fragment } from "react";
import { connect } from "react-redux";

export type ContentPageProps = {
  actionLinkProps?: {
    onClick: () => void;
    text: string;
  };
  configuration: {
    imageAlignment: string;
    imageSize: number;
    pageLayout: string;
    showMap: boolean;
    textAlignment: string;
  };
  data: EditableResourceFields[];
  pageData: Page;
  id: string;
  title: string;
};

type ContentPagePropsWithRedux = {
  fullPhoto: Photo | null;
} & ContentPageProps;

const ContentPage = ({
  actionLinkProps,
  configuration,
  data,
  fullPhoto,
  id,
  pageData,
  title,
}: ContentPagePropsWithRedux) => {
  const isCentered = configuration.textAlignment === "center";
  const pageDataImageOverride: Page = {
    ...pageData,
    image: pageData.image || fullPhoto?.original || null,
  };

  return (
    <PageComponent
      id={id}
      pageData={pageDataImageOverride}
      removeSpacing
      title={title}
    >
      <WrapperMedium>
        {data.map((item: EditableResourceFields) => (
          <Fragment key={item.id}>
            <Content
              {...item}
              actionLinkProps={actionLinkProps}
              configuration={configuration}
              photoPk={item.photo}
            />
            <PageContentSeparator
              extraStyles={[hideLast, ...(isCentered ? [] : [hideMd])]}
              isCentered
            />
          </Fragment>
        ))}
      </WrapperMedium>
    </PageComponent>
  );
};

const mapStateToProps = (state: RootState, props: ContentPageProps) => ({
  fullPhoto: getPhotoByPk(state, props.pageData.photo),
});

export default connect(mapStateToProps)(
  ContentPage,
) as unknown as React.FC<ContentPageProps>;
